<template>
  <div class="bgbox">
    <div class="contanier">
      <div class="centerbox">
        <div class="iconbox">
            <img src="../../assets/icon.jpg" alt="">
          </div>
        <div class="flex topbox">     
          <div class="flex">
            <div class="applogo">
              <img src="../../assets/code.png" alt="" />
            </div>
            <div class="appname">
              <p class="codebox">小趣同学</p>
              <p style="font-size: 12px">Xiaoqu Classmate</p>
            </div>
          </div>
            <div class="flex a-end">
          <div class="codebox">
            <p style="margin-bottom: 10px">{{ $t("message.download") }}</p>
            <div class="applogo">
              <img src="../../assets/code.png" alt="" />
            </div>
          </div>
          <div class="logobox" style="margin: 0 40px 0 0">
            <a href="">
              <img src="../../assets/iphone.png" alt="" />
            </a>
          </div>
          <div class="logobox">
            <a href="">
              <img src="../../assets/android.png" alt="" />
            </a>
          </div>
        </div>
        </div>
          <div class="downloadlink">
            <!-- <p>{{ $t("message.list") }}</p> -->
            <p>App Store(苹果应用市场)</p>
            <p>Google Play(谷歌应用市场)</p>
            <p>({{ $t("message.application") }})</p>
            <p>{{ $t("message.store") }}</p>
            <p>{{ $t("message.install") }}</p>
          </div>
      </div>
    </div>
    <div class="product">
      <div class="flex caption-top flex-c">
        <div class="prodects">
          <div class="flex flex-b">
            <div>
              <h4>{{$t("message.productlist")}}</h4>
            </div>

            <div class="flex a-c">
              <h4>搜索</h4>
              <el-input
                v-model="formdata.keywords"
                @change="getList"
                style="width: 240px; margin-left: 5px"
                size="large"
                placeholder="请输入内容"
              />
            </div>
            <div @click="touch">
              <el-button type="primary">
      批量下载<el-icon class="el-icon--right"><Download /></el-icon>
    </el-button>
            </div>
          </div>
          <hr />
          <div>
            <el-table
              v-loading.fullscreen.lock="loading"
              element-loading-text="请稍等，正在下载产品资料"
              :data="productList"
              :default-sort="{ prop: 'date' }"
              :row-class-name="tableRowClassName"
              @row-click="rowClick"
              @selection-change="handleSelectionChange"
              style="width: 100%"
            >
              <el-table-column type="selection" width="55" />
              <el-table-column :label="$t('message.picture')" width="80">
        <template #default="scope">
          <div class="demo-image__preview line-heightOne">
            <el-image :src="scope.row.image" :preview-src-list="[scope.row.image]" />
          </div>
        </template>
      </el-table-column>
              <el-table-column prop="productName" :label="$t('message.name')" width="180">
              </el-table-column>
              <el-table-column
                prop="createTime"
                :label="$t('message.times')"
                sortable
                width="180"
              >
              </el-table-column>
              <el-table-column :label="$t('message.download')"> </el-table-column>
            </el-table>
          </div>
          <div class="demo-pagination-block">
            <el-pagination
              v-model:current-page="formdata.page"
              v-model:page-size="formdata.limit"
              :page-sizes="[20, 30, 40, 50]"
              layout="total, sizes, prev, pager, next"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>

        <!-- <div>
       <div class="flex material">
         <div class="sourceimg">
          <img src="../../assets/code.png" alt="">
        </div>
        <p>LOGO下载</p>
       </div>
        <div class="flex material" >
          <div class="sourceimg">
          <img src="../../assets/code.png" alt="">
        </div>
        <p>素材下载</p>
        </div>
      </div> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { proListApi, downloadZipApi } from "@/api/index.js";
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
import { Download } from '@element-plus/icons-vue'
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  getCurrentInstance,
} from "vue";
import { ElMessage } from 'element-plus'
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
const { proxy } = getCurrentInstance();
const store = useStore();
const route = useRoute();
const router = useRouter();
onMounted(() => {
  getList();
});
let formdata = ref({ classId: 0, keywords: null, limit: 20, page: 1,pid:0 });
let total = ref(0);
let productList = ref([]);
let loading = ref(false);
// 一键下载
const touch = () => {
  if (multipleSelection.value.length>0) {
    loading.value = true;
    multipleSelection.value.forEach(item=>{
      window.open(item);
    })
    loading.value = false;
  // downloadZipApi(multipleSelection.value)
  //   .then((res) => {
  //     window.open(res);
  //     ElMessage.success("下载成功");
  //     loading.value = false;
  //   })
  //   .catch((err) => {
  //     console.log(err);
  //     loading.value = false;
  //   });

  }else{
      ElMessage.error("请先选择产品列表");

  }

};
// const touch = () => {
//   if (multipleSelection.value.length > 0) {
//     loading.value = true;
//
//     multipleSelection.value.forEach((item, index) => {
//       // 为每个打开操作添加延迟
//       setTimeout(() => {
//         window.open(item);
//
//         // 如果是最后一个，关闭loading
//         if (index === multipleSelection.value.length - 1) {
//           loading.value = false;
//         }
//       }, index * 100); // 100ms间隔，可根据需要调整
//     });
//   } else {
//     ElMessage.error("请先选择产品列表");
//   }
// };
const multipleSelection = ref([]);
const handleSelectionChange = (val) => {
  const tables = [];
  val.map((item) => {
    tables.push(item.ossPathAll);
  });
  multipleSelection.value = tables;
};
const getList = () => {
  proListApi(formdata.value)
    .then((res) => {
      productList.value = res.list;
      total.value = res.total;
    })
    .catch((err) => {
      console.log(err);
    });
};
const tableRowClassName = (row) => {
  if (row.rowIndex % 2 == 1) {
    return "warning-row";
  } else {
    return "";
  }
};
const rowClick = (row) => {
  console.log(row.id);

  let formData = JSON.stringify(formdata.value);
  router.push({
    name: "materials",
    query: { formData, id: row.id },
  });
};
// 分页
const handleSizeChange = (val) => {
  formdata.value.limit = val;
  formdata.value.page = 1;
  getList();
};
const handleCurrentChange = (val) => {
  formdata.value.page = val;
  getList();
};
</script>
<style scoped lang="scss">
.contanier {
  width: 100%;
  height: 297px;
  background-image: url(../../assets/haibao.png);
  background-size: 100% 100%;
  background-color: #000;
}
.bgbox {
  width: 100%;
  height: 100%;
}
.centerbox {
  // width: 60%;
  margin: auto;
  padding: 65px 300px 40px 505px;
  height: 100%;
  display: flex;
  // flex-direction: column;
  // justify-content: space-between;
}
.logobox {
  width: 250px;
  height: 43px;
}
.downloadlink {
  color: #fff;
  text-align: right;
}
.applogo {
  width: 71px;
  height: 71px;
  margin-right: 40px;
}
.topbox {
  flex-direction: column;
  justify-content: space-between;
  margin: 0 150px;
}
.appname {
  font-size: 28px;
  font-weight: 600;
  color: #fff;
}
.codebox {
  color: #fff;
  text-align: left;
}
.product {
  width: 100%;
  height: 100%;
  background-color: #ededed;
  display: flex;
  justify-content: center;
}
.caption-top {
  width: 55%;
  margin: 50px 0;
}
.prodects {
  background-color: #fff;
  width: 75%;
  margin-right: 30px;
  padding: 30px 10px 10px;
  font-size: 24px;
  color: #212529;
}
::v-deep .el-table .warning-row {
  --el-table-tr-bg-color: #dfdfdf;
}
::v-deep .el-table {
  color: #000;
}
.demo-pagination-block {
  margin-top: 10px;
}
.material {
  width: 305px;
  height: 105px;
  background-color: #fff;
  margin-bottom: 20px;
  padding: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sourceimg {
  width: 50px;
  height: 50px;
}
.iconbox{
  width: 75px;
  img{
    width: 160px;
  }
}
</style>